export default __webpack_public_path__ + "static/media/bernay13.f32160b1.jpg";